export const HOSPITALS = [
  '100 Mile District General Hospital',
  'Abbotsford Regional Hospital and Cancer Centre',
  'Aberdeen Hospital',
  'Arrow Lakes Hospital',
  'Ashcroft and District Hospital',
  "B.C. Women's Hospital & Health Centre",
  'BC Cancer Agency',
  'Bella Coola General Hospital',
  'Boundary Hospital',
  "British Columbia's Children's Hospital & Sunny Hill Health Centre for Children",
  'Bulkley Valley District Hospital',
  'Burnaby General Hospital',
  'Campbell River & District General Hospital',
  'Cariboo Memorial Hospital',
  'Castlegar and District Community Health Centre',
  'Chemainus Health Care Centre',
  'Chetwynd General Hospital',
  'Chilliwack General Hospital',
  'Cormorant Island Community Health Centre',
  'Cowichan District Hospital',
  'Creston Valley Hospital',
  'Dawson Creek and District Hospital',
  'Delta Hospital',
  'Dr. Helmcken Memorial Hospital',
  'Eagle Park Health Care Facility',
  'Eagle Ridge Hospital',
  'East Kootenay Regional Hospital',
  'Elk Valley Hospital',
  'Fort Nelson General Hospital',
  'Fort St. John General Hospital',
  'Fraser Canyon Hospital',
  'G.R. Baker Memorial Hospital',
  'Glengarry Hospital',
  'Golden and District General Hospital',
  'Invermere and District Hospital',
  'Kelowna General Hospital',
  'Kitimat General Hospital',
  'Kootenay Boundary Regional Hospital',
  'Kootenay Lake Hospital',
  'Lady Minto Gulf Islands Hospital',
  'Ladysmith Community Health Centre',
  'Lakes District Hospital and Health Centre',
  'Langley Memorial Hospital',
  'Lillooet District Hospital',
  'Lions Gate Hospital',
  'Mackenzie and District Hospital',
  'McBride and District Hospital',
  'Menno Hospital',
  'Mills Memorial Hospital',
  'Mission Memorial Hospital',
  'Mount Saint Joseph Hospital',
  'Mount St. Francis Hospital',
  'Mt. Tolmie Hospital',
  'Nanaimo Regional General Hospital',
  'Nicola Valley Health Centre',
  'Peace Arch Hospital',
  'Penticton Regional Hospital',
  'Port Alice Hospital',
  'Port Hardy Hospital',
  'Port McNeill and District Hospital',
  'Powell River General Hospital',
  'Prince Rupert Regional Hospital',
  'Princeton General Hospital',
  'Priory Hospital',
  'Queen Charlotte Islands General Hospital',
  'Queen Victoria Hospital',
  'R.W. Large Memorial Hospital',
  'Richmond Hospital',
  'Ridge Meadows Hospital & Health Care Centre',
  'Riverview Hospital',
  'Royal Columbian Hospital',
  'Royal Inland Hospital',
  'Royal Jubilee Hospital',
  'Saanich Peninsula Hospital',
  'Shuswap Lake General Hospital',
  'Slocan Community Health Centre',
  'South Okanagan General Hospital',
  'Sparwood Health Centre',
  'Squamish General Hospital',
  "St. Bartholomew's Hospital",
  'St. John Hospital',
  "St. Joseph's Hospital (see also Mount Saint Joseph Hospital above)",
  "St. Mary's Hospital",
  "St. Paul's Hospital",
  'Stewart Health Centre',
  'Stuart Lake General Hospital',
  'Summerland Health Centre',
  'Sunny Hill Health Centre for Children',
  'Surrey Memorial Hospital',
  'Tofino General Hospital',
  'Trillium Lodge',
  'UBC Hospital',
  'University Hospital of Northern British Columbia',
  'Vancouver General Hospital',
  'Vancouver Hospital and Health Sciences Centre',
  'Vernon Jubilee Hospital',
  'Victoria General Hospital',
  'Victorian Community Health Centre of Kaslo',
  'West Coast General Hospital',
  'Whistler Health Care Centre',
  'Wrinch Memorial Hospital'
];
